module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "CardSatelliteImage"
  }, [(_vm.addTransparentLayer) ? _c('div', {
    staticClass: "transparent-layer"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "googleMap",
    staticClass: "MapRef"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a3d87164","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reports/CircularGraphicsComponents/SatelliteImage.vue
// module id = 1749
// module chunks = 0